"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViacomAccountService = exports.viacomAccountService = void 0;
var viacom_account_service_1 = require("./viacom-account.service");
Object.defineProperty(exports, "viacomAccountService", { enumerable: true, get: function () { return viacom_account_service_1.viacomAccountService; } });
Object.defineProperty(exports, "ViacomAccountService", { enumerable: true, get: function () { return viacom_account_service_1.ViacomAccountService; } });
